// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "code_0.9.3_" + chunkId + ".bundle.js";
};